import { KM_NAME_ATTR_CODE } from './constants';
import type { KmEntity } from './types';

/** Код атрибута, значение которого составляет содержание экземпляра */
const TEXT_ATTR_CODE = 'text';

/**
 * Название экземпляра модели знаний: значение атрибута `name`, а без него — номер экземпляра.
 * Одно правило именования для списка, карточки и вторых сторон связей.
 */
export const getKmEntityTitle = (entity: KmEntity): string => {
  const name = entity.data[KM_NAME_ATTR_CODE];
  return typeof name === 'string' && name.trim() ? name : `#${entity.id}`;
};

/**
 * Содержание экземпляра модели знаний: значение атрибута `text`; пусто — атрибута у типа нет
 * или он не заполнен.
 */
export const getKmEntityText = (entity: KmEntity): string => {
  const text = entity.data[TEXT_ATTR_CODE];
  return typeof text === 'string' ? text : '';
};
